// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"87c4338d","271":"8db3e920","365":"8fdf9eb6","496":"c314c6ac","519":"1d07b4dd","548":"485db121","669":"244c0cb1","752":"e66db58b","865":"f4a31251","953":"26481d15"}[chunkId] + ".chunk.js";
};